/**
 * Level-1 category visible to the agent group.
 * Empty / missing visibelGroup = visible to all (matches current DB + admin leave-blank cases).
 */
export function isCategoryVisibleToGroup (category, userGroupId) {
  if (!category || Number(category.level) !== 1) return false
  const groups = category.visibelGroup
  if (!Array.isArray(groups) || groups.length === 0) return true
  if (userGroupId == null || userGroupId === '') return false
  const gid = Number(userGroupId)
  // Set once for larger visibility lists (skills/performance: Map/Set over repeated scans)
  if (groups.length > 8) {
    const allowed = new Set(groups.map((g) => Number(g)))
    return allowed.has(gid)
  }
  return groups.some((g) => Number(g) === gid)
}

export function filterLevelOneCategories (categories, userGroupId) {
  if (!Array.isArray(categories)) return []
  return categories.filter((item) => isCategoryVisibleToGroup(item, userGroupId))
}

/**
 * Keep a currently selected category in options even when group visibility
 * no longer includes it (legacy tickets after visibelGroup was tightened).
 * Without this, v-select shows the raw id instead of the name.
 */
export function ensureSelectedCategoryInOptions (options, selectedId, categories) {
  if (selectedId == null || selectedId === '') {
    return Array.isArray(options) ? options : []
  }
  const id = Number(selectedId)
  if (!Number.isFinite(id)) {
    return Array.isArray(options) ? options : []
  }
  const list = Array.isArray(options) ? options.slice() : []
  if (list.some((item) => Number(item?.id) === id)) {
    return list
  }
  if (!Array.isArray(categories)) {
    return list
  }
  const found = categories.find((item) => Number(item?.id) === id)
  if (found) {
    list.unshift(found)
  }
  return list
}
